goog.require('el8.template.multiuser_access.signin');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.signin = (function() {

    var that = {};
    var userProfile = null;
    var theForm = null;
    var faxCode = null;
    var numWrongPassword = 0;

    function inputChanged(event) {
        $('.el8ErrorAlert').fadeOut();
       if (event && (event.which === 13 || event.keyCode === 13)) {
           // submit the form
           goToChart(faxCode, theForm.getVal("password"));
           return;
       }
       if (theForm.getVal('password')) {
           $('#go-to-chart').prop('disabled', false);
       } else {
           $('#go-to-chart').prop('disabled', true);
       }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function goToChart(faxCode, submittedPassword) {
        // signup and go to chart

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('signinSubmit', [faxCode, userProfile.id]),
            data: JSON.stringify({ password: submittedPassword }),
            async: true,
            success: function(data) {
                if (!data.error) {
                    location.href=data.location;
                } else {
                    $('.el8ErrorAlert').show();
                    numWrongPassword++;

                    if (numWrongPassword >= 3) {
                        location.href=el8.service.urls.get('pageBadPasswordAutodetect', [faxCode, userProfile.id]);
                    }
                }
            }
        });
    }

    function setupKeyPressedListeners() {
        $(document).on('keypress', ':input[name="password"]', debouncedInputChanged);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        userProfile = spec.userProfile;
        var passwordQAUrl = spec.passwordQAUrl;
        faxCode = spec.faxCode;

        $('.main-content').html(
            el8.template.multiuser_access.signin.content({
                userProfile: userProfile,
                passwordHelpTriageUrl: el8.service.urls.get('pagePasswordHelpTriage', [faxCode, userProfile.id])
            })
        );

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'password',
                selector: ':input[name="password"]',
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();

        inputChanged();

        $('.el8ErrorAlert').hide();

        setupKeyPressedListeners();

        $(document).on('click', '#go-to-chart', function(event) {
            goToChart(faxCode, theForm.getVal("password"));
        });

    };

    return that;

})();